import EventFinderCarousel from '../../../../components/containers/EventFinderCarousel';
import preloadCustomProps from '../../../utils/preloads/preloadStaticContainerProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'event-finder-carousel',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: EventFinderCarousel
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
